import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { activeDelivery } from '../data/dummyData';

const TrackingPage = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(2);
  const [callVisible, setCallVisible] = useState(false);

  const steps = [
    { label: '요청 완료', time: '09:30', desc: '서비스 요청이 접수되었습니다', icon: '📝', done: true },
    { label: '매니저 배정', time: '09:35', desc: '김철수 영차매니저가 배정되었습니다', icon: '🧑', done: true },
    { label: '현장 출발', time: '10:05', desc: '판매자 주소로 이동 중입니다', icon: '🚗', done: true },
    { label: '현장 도착', time: '10:30', desc: '판매자 현장에 도착했습니다', icon: '📍', done: currentStep >= 3 },
    { label: '상품 검증 중', time: currentStep >= 4 ? '10:45' : '-', desc: '상품 상태를 꼼꼼히 확인 중입니다', icon: '🔍', done: currentStep >= 4 },
    { label: '검증 완료', time: currentStep >= 5 ? '11:00' : '-', desc: '상품 상태 양호 - 배송 진행', icon: '✅', done: currentStep >= 5 },
    { label: '기본 세척', time: currentStep >= 6 ? '11:20' : '-', desc: '가구 기본 세척을 완료했습니다', icon: '🧹', done: currentStep >= 6 },
    { label: '배송 출발', time: currentStep >= 7 ? '11:35' : '-', desc: '배송지를 향해 출발했습니다', icon: '🚚', done: currentStep >= 7 },
    { label: '배송 완료', time: currentStep >= 8 ? '12:30' : '-', desc: '배송이 완료되었습니다!', icon: '🎉', done: currentStep >= 8 },
  ];

  const currentStepInfo = steps[Math.min(currentStep, steps.length - 1)];

  const mockPhotos = [
    { label: '상품 정면', emoji: '🛋️', ok: true },
    { label: '상품 측면', emoji: '📐', ok: true },
    { label: '하자 체크', emoji: '🔍', ok: true },
    { label: '세척 완료', emoji: '✨', ok: currentStep >= 6 },
  ];

  return (
    <div className="page-white">
      {/* 헤더 */}
      <div style={{ background: 'linear-gradient(135deg, #2980B9 0%, #3498DB 100%)', padding: '20px 20px 24px' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 10, padding: '8px 12px', color: 'white', cursor: 'pointer', marginBottom: 12 }}
        >← 뒤로</button>
        <div style={{ color: 'white', fontSize: 22, fontWeight: 800, marginBottom: 4 }}>
          🚚 배송 실시간 추적
        </div>
        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13 }}>
          주문번호: ORD-20260303-0042
        </div>
      </div>

      <div style={{ padding: '20px 20px 100px' }}>
        {/* 현재 상태 강조 카드 */}
        <div style={{
          background: 'linear-gradient(135deg, #2980B9 0%, #3498DB 100%)',
          borderRadius: 16, padding: '20px', marginBottom: 20, color: 'white'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
            <span style={{ fontSize: 36 }}>{currentStepInfo?.icon}</span>
            <div>
              <div style={{ fontSize: 13, opacity: 0.8 }}>현재 상태</div>
              <div style={{ fontWeight: 800, fontSize: 20 }}>{currentStepInfo?.label}</div>
            </div>
          </div>
          <div style={{ fontSize: 13, opacity: 0.85, lineHeight: 1.6, marginBottom: 12 }}>
            {currentStepInfo?.desc}
          </div>

          {/* 진행 바 */}
          <div style={{ height: 6, background: 'rgba(255,255,255,0.25)', borderRadius: 3, marginBottom: 8 }}>
            <div style={{
              width: `${((currentStep + 1) / steps.length) * 100}%`,
              height: '100%', background: 'white', borderRadius: 3,
              transition: 'width 0.5s ease'
            }}/>
          </div>
          <div style={{ fontSize: 12, opacity: 0.8 }}>
            {currentStep + 1}/{steps.length} 단계 완료
          </div>

          {currentStep < steps.length - 1 && (
            <button
              onClick={() => setCurrentStep(prev => Math.min(prev + 1, steps.length - 1))}
              style={{
                marginTop: 12, background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.4)',
                borderRadius: 8, padding: '8px 16px', color: 'white', cursor: 'pointer',
                fontSize: 12, fontWeight: 600
              }}
            >
              다음 단계 시뮬레이션 →
            </button>
          )}
        </div>

        {/* 매니저 정보 */}
        <div style={{ background: 'white', borderRadius: 16, padding: 16, marginBottom: 16, border: '1px solid #E5E7EB', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <div style={{ width: 52, height: 52, borderRadius: '50%', background: '#FFF0EB', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26 }}>
                🧑
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937' }}>김철수 영차매니저</div>
                <div style={{ fontSize: 12, color: '#9CA3AF' }}>1톤 트럭 | 서울 12가 3456</div>
                <div style={{ color: '#F39C12', fontSize: 12, marginTop: 2 }}>⭐ 4.9 (312건)</div>
              </div>
            </div>
            <button
              onClick={() => setCallVisible(true)}
              style={{
                background: '#27AE60', color: 'white', border: 'none',
                borderRadius: 12, padding: '10px 14px', cursor: 'pointer',
                fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', gap: 6
              }}
            >
              📞 연락
            </button>
          </div>
        </div>

        {/* 검증 사진 */}
        {currentStep >= 3 && (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 10 }}>
              📸 현장 검증 사진
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              {mockPhotos.map((photo, i) => (
                <div
                  key={i}
                  style={{
                    background: photo.ok ? '#e8f8ef' : '#F9FAFB',
                    borderRadius: 12, padding: '20px 16px', textAlign: 'center',
                    border: `1px solid ${photo.ok ? '#27AE60' : '#E5E7EB'}`
                  }}
                >
                  <div style={{ fontSize: 32, marginBottom: 8 }}>{photo.ok ? photo.emoji : '⏳'}</div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: photo.ok ? '#27AE60' : '#9CA3AF' }}>
                    {photo.label}
                  </div>
                  <div style={{ fontSize: 11, color: photo.ok ? '#27AE60' : '#9CA3AF', marginTop: 2 }}>
                    {photo.ok ? '✓ 완료' : '대기 중'}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 타임라인 */}
        <div style={{ background: 'white', borderRadius: 16, padding: 20, marginBottom: 16, border: '1px solid #E5E7EB' }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 16 }}>
            📋 서비스 진행 단계
          </div>
          <div className="timeline">
            {steps.map((s, i) => (
              <div key={i} className="timeline-item">
                <div className={`timeline-dot ${s.done ? 'done' : i === currentStep + 1 ? 'active' : ''}`}/>
                <div style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
                  opacity: !s.done && i > currentStep + 1 ? 0.4 : 1
                }}>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <span style={{ fontSize: 14 }}>{s.icon}</span>
                      <span style={{
                        fontWeight: s.done || i === currentStep ? 700 : 500,
                        fontSize: 14,
                        color: s.done ? '#27AE60' : i === currentStep + 1 ? '#2980B9' : '#9CA3AF'
                      }}>
                        {s.label}
                      </span>
                      {i === currentStep && <span style={{ background: '#2980B9', color: 'white', fontSize: 10, padding: '2px 6px', borderRadius: 6, fontWeight: 700 }}>진행중</span>}
                    </div>
                    <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>{s.desc}</div>
                  </div>
                  <span style={{ fontSize: 12, color: s.done ? '#27AE60' : '#9CA3AF', fontWeight: 600, whiteSpace: 'nowrap', marginLeft: 8 }}>
                    {s.time}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 배송 정보 */}
        <div style={{ background: '#F9FAFB', borderRadius: 16, padding: 16, marginBottom: 16 }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: '#1F2937', marginBottom: 10 }}>📦 배송 상세</div>
          {[
            { label: '상품', val: '3인용 소파' },
            { label: '픽업지', val: '서울 마포구 합정동' },
            { label: '배송지', val: '서울 은평구 응암동' },
            { label: '예상 도착', val: '오후 1시 30분' },
            { label: '요금', val: '35,000원' },
          ].map((item, i) => (
            <div key={i} className="info-row">
              <span className="info-key">{item.label}</span>
              <span className="info-val">{item.val}</span>
            </div>
          ))}
        </div>

        {/* 검증 완료 후 선택지 */}
        {currentStep >= 4 && currentStep < 8 && (
          <div style={{ background: '#e8f8ef', borderRadius: 16, padding: 20, marginBottom: 16 }}>
            <div style={{ fontWeight: 700, fontSize: 15, color: '#27AE60', marginBottom: 8 }}>
              ✅ 검증 결과: 상태 양호
            </div>
            <div style={{ fontSize: 13, color: '#166534', lineHeight: 1.6, marginBottom: 14 }}>
              상품 상태가 양호합니다. 특이한 하자가 발견되지 않았습니다. 배송을 진행하시겠어요?
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                style={{
                  flex: 1, padding: '12px', borderRadius: 12,
                  background: 'white', border: '2px solid #E74C3C', color: '#E74C3C',
                  fontWeight: 700, fontSize: 13, cursor: 'pointer'
                }}
                onClick={() => alert('구매 취소 처리되었습니다. 검증비(15,000원)만 청구됩니다.')}
              >
                ❌ 구매 취소
              </button>
              <button
                style={{
                  flex: 1, padding: '12px', borderRadius: 12,
                  background: '#27AE60', color: 'white', border: 'none',
                  fontWeight: 700, fontSize: 13, cursor: 'pointer'
                }}
                onClick={() => setCurrentStep(5)}
              >
                ✅ 배송 진행
              </button>
            </div>
          </div>
        )}

        {currentStep === steps.length - 1 && (
          <div style={{ background: 'linear-gradient(135deg, #FF6B35, #FF8C5A)', borderRadius: 16, padding: 20, color: 'white', textAlign: 'center', marginBottom: 16 }}>
            <div style={{ fontSize: 48, marginBottom: 8 }}>🎉</div>
            <div style={{ fontWeight: 800, fontSize: 20, marginBottom: 4 }}>배송 완료!</div>
            <div style={{ fontSize: 13, opacity: 0.9 }}>소파가 안전하게 배송되었습니다</div>
            <button
              onClick={() => alert('감사합니다! 리뷰를 작성해 주세요 😊')}
              style={{
                marginTop: 16, background: 'white', color: '#FF6B35', border: 'none',
                borderRadius: 10, padding: '10px 24px', fontWeight: 700, cursor: 'pointer'
              }}
            >
              ⭐ 리뷰 작성하기
            </button>
          </div>
        )}
      </div>

      {/* 연락 모달 */}
      {callVisible && (
        <div className="modal-overlay" onClick={() => setCallVisible(false)}>
          <div className="modal-sheet" onClick={e => e.stopPropagation()}>
            <div className="modal-handle"/>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 48, marginBottom: 8 }}>📞</div>
              <div style={{ fontWeight: 700, fontSize: 18 }}>김철수 영차매니저</div>
              <div style={{ fontSize: 14, color: '#9CA3AF', marginTop: 4 }}>010-XXXX-XXXX</div>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={() => { setCallVisible(false); alert('카카오톡으로 메시지를 보냅니다'); }}
                style={{ flex: 1, padding: '14px', borderRadius: 12, background: '#FEE500', border: 'none', fontWeight: 700, cursor: 'pointer' }}
              >💬 카카오톡</button>
              <button
                onClick={() => { setCallVisible(false); alert('전화를 연결합니다'); }}
                style={{ flex: 1, padding: '14px', borderRadius: 12, background: '#27AE60', color: 'white', border: 'none', fontWeight: 700, cursor: 'pointer' }}
              >📞 전화하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrackingPage;
